import { Component } from '@angular/core';
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-inclusion-eis',
  templateUrl: './inclusion-eis.component.html',
  styleUrls: ['./inclusion-eis.component.scss'],
})
export class InclusionEisComponent {
  images: Image[] = [
    {
      src: 'assets/img/school/inclusion/eis/1.jpg',
      thumbnail: 'assets/img/school/inclusion/eis/1.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/eis/2.jpg',
      thumbnail: 'assets/img/school/inclusion/eis/2.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/eis/3.jpg',
      thumbnail: 'assets/img/school/inclusion/eis/3.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/eis/4.jpg',
      thumbnail: 'assets/img/school/inclusion/eis/4.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/eis/5.jpg',
      thumbnail: 'assets/img/school/inclusion/eis/5.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/inclusion/eis/6.jpg',
      thumbnail: 'assets/img/school/inclusion/eis/6.jpg',
      alt: 'Image 01',
    },
  ];
}
